// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"83d459ca","396":"dadae862","508":"4245aa20","552":"16c2465f","569":"6c89456f","673":"0db957d0","793":"0da537c4"}[chunkId] + ".chunk.css";
};